package org.moxultimate.topwithmox.tech.ui

import androidx.compose.runtime.Immutable
import org.moxultimate.topwithmox.tech.data.TechResponse

/**
 * TechState
 * Screen states for the Tech/How-To page driven by [TechViewModel].
 */
@Immutable
sealed class TechState {
    /** Initial loading state before any data has been received. */
    data object Loading : TechState()

    /**
     * Error state when the API call fails.
     *
     * @param message   Human-readable error description.
     * @param statusCode HTTP status code (0 when no response was received).
     */
    data class Error(val message: String, val statusCode: Int = 0) : TechState()

    /**
     * Success state containing the filtered tech list and pagination flag.
     *
     * @param techList Accumulated (and optionally filtered) list of tech entries.
     * @param hasMore  False when all pages have been loaded from the server.
     */
    data class Success(
        val techList: List<TechResponse>,
        val hasMore: Boolean = true,
    ) : TechState()
}
